import { TitleBase } from '@website-builder/model/style/title-base';

export class AccordionTitleStyle extends TitleBase {
  static normalize(styles: Partial<AccordionTitleStyle>): AccordionTitleStyle {
    const titleBase: TitleBase = TitleBase.normalize(styles);
    const pureStyles = new AccordionTitleStyle();

    Object.assign(pureStyles, titleBase);

    return pureStyles;
  }
}
